// =============================================================================
// src/chrome/static-shell/index.ts — blocos estaticos de chrome do shell.
//
// Proveniencia: markup FIEL de unified.html — region popup (277-285),
//   command palette (1812-1837), overflow menu (1839-1862), account menu
//   (1863-1887), mini-toast host (1888) e a doca de superficies (1893-1932).
//   Comportamento: TopbarNav/SearchPalette (assets/unified-app.js) +
//   crisis/reputation/copilot-chat.js (FABs da doca). render-only.
// =============================================================================

import { TOPBAR_OPERATOR, operatorInitials } from '../topbar/topbar-identity';

/** Region popup (#u-popup) — montado em #regionPopupMount. */
export function buildRegionPopupMarkup(): string {
  return REGION_POPUP_MARKUP;
}

/** Palette + popovers + toast host + doca — montados em #routeLayer. */
export function buildChromeOverlaysMarkup(): string {
  return [SEARCH_PALETTE_MARKUP, OVERFLOW_MENU_MARKUP, ACCOUNT_MENU_MARKUP, TOAST_HOST_MARKUP, SURFACE_DOCK_MARKUP].join('\n\n');
}

const REGION_POPUP_MARKUP = `    <div class="u-region-popup" id="u-popup">
      <div class="pop-title" id="u-popTitle">Zona Norte</div>
      <div class="pop-sub" id="u-popSub">692.000 hab · 412.000 eleitores</div>
      <div class="pop-row"><span class="k">1º colocado</span><span class="v" id="u-popFirst">Avante (52%)</span></div>
      <div class="pop-row"><span class="k">2º colocado</span><span class="v" id="u-popSecond">PL (38%)</span></div>
      <div class="pop-row"><span class="k">IDH</span><span class="v">0,687</span></div>
      <div class="pop-row"><span class="k">Tendência</span><span class="v" style="color:var(--color-text-success)"><i class="ti ti-trending-up" style="font-size:11px"></i> estável</span></div>
      <button class="u-cta-btn" id="u-pop-cta" style="width:100%;margin-top:8px">ver perfil completo</button>
    </div>`;
const SEARCH_PALETTE_MARKUP = `<div class="u-search-palette" id="searchPalette" aria-hidden="true" role="dialog" aria-modal="true" aria-label="Buscar no Mapa Político">
  <div class="u-search-palette-backdrop" data-close="palette"></div>
  <div class="u-search-palette-panel" role="document">
    <div class="u-search-palette-input-row">
      <i class="ti ti-search" aria-hidden="true"></i>
      <input
        type="text"
        id="searchPaletteInput"
        class="u-search-palette-input"
        placeholder="Buscar regiões, pessoas, organizações, partidos…"
        autocomplete="off"
        spellcheck="false"
        aria-controls="searchPaletteResults"
        aria-activedescendant=""
      >
      <kbd class="u-kbd">esc</kbd>
    </div>
    <div class="u-search-palette-results" id="searchPaletteResults" role="listbox" aria-label="Resultados"></div>
    <div class="u-search-palette-foot">
      <span><kbd class="u-kbd">↑↓</kbd> navegar</span>
      <span><kbd class="u-kbd">↵</kbd> abrir</span>
      <span><kbd class="u-kbd">esc</kbd> fechar</span>
    </div>
  </div>
</div>
`;
const OVERFLOW_MENU_MARKUP = `<div class="u-topbar-popover" id="topbarOverflowMenu" hidden role="menu" aria-label="Mais ações">
  <div class="u-topbar-popover-section-label">Contexto</div>
  <button type="button" class="u-topbar-popover-item" role="menuitem" data-action="context">
    <i class="ti ti-calendar-event" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Eleição Municipal 2024</span>
    <i class="ti ti-check u-topbar-popover-item-check" aria-hidden="true"></i>
  </button>
  <div class="u-topbar-popover-sep u-topbar-popover-mobile-only" role="separator"></div>
  <div class="u-topbar-popover-section-label u-topbar-popover-mobile-only">Navegação</div>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="view-briefing">
    <i class="ti ti-layout-dashboard" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Briefing</span>
  </button>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="view-explore">
    <i class="ti ti-compass" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Explorar</span>
  </button>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="view-mapa" disabled aria-disabled="true" title="Feed do Mapa indisponível">
    <i class="ti ti-map" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Mapa</span>
  </button>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="view-grafo" disabled aria-disabled="true" title="Grafo de Influências indisponível">
    <i class="ti ti-graph" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Grafo</span>
  </button>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="view-workspace">
    <i class="ti ti-briefcase" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Workspace</span>
  </button>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="view-cinema" disabled aria-disabled="true" title="Modo Cinema indisponível">
    <i class="ti ti-movie" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Cinema</span>
  </button>
  <div class="u-topbar-popover-sep u-topbar-popover-mobile-only" role="separator"></div>
  <div class="u-topbar-popover-section-label u-topbar-popover-mobile-only">Inteligência</div>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="surface-crisis" disabled aria-disabled="true" title="Gestão de Crise indisponível">
    <i class="ti ti-shield" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Gestão de Crise</span>
  </button>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="surface-analytics">
    <i class="ti ti-chart-line" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Analytics</span>
  </button>
  <button type="button" class="u-topbar-popover-item u-topbar-popover-mobile-only" role="menuitem" data-action="surface-copilot" disabled aria-disabled="true" title="Copiloto IA indisponível">
    <i class="ti ti-sparkles" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Copiloto IA</span>
  </button>
  <div class="u-topbar-popover-sep" role="separator"></div>
  <div class="u-topbar-popover-section-label">Ações</div>
  <button type="button" class="u-topbar-popover-item" role="menuitem" data-action="bookmark" disabled aria-disabled="true" title="Salvar vista atual indisponível">
    <i class="ti ti-bookmark" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Salvar vista atual</span>
  </button>
  <button type="button" class="u-topbar-popover-item" role="menuitem" data-action="download" disabled aria-disabled="true" title="Exportar dados indisponível">
    <i class="ti ti-download" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Exportar dados</span>
  </button>
  <!-- "Apresentar" e a porta DESKTOP do Modo Cinema (runOverflowAction -> go('cinema')).
       Desativada junto com o Cinema em 2026-07-20: sem isto sobraria um item de menu
       clicavel que nao faz nada, já que go('cinema') virou no-op. -->
  <button type="button" class="u-topbar-popover-item" role="menuitem" data-action="present" disabled aria-disabled="true" title="Modo Cinema indisponível">
    <i class="ti ti-presentation" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Apresentar</span>
  </button>
  <div class="u-topbar-popover-sep" role="separator"></div>
  <div class="u-topbar-popover-section-label">Transparência</div>
  <button type="button" class="u-topbar-popover-item" role="menuitem" data-action="mapa-ia" disabled aria-disabled="true" title="Mapa de IA indisponível">
    <i class="ti ti-sparkles" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Mapa de IA</span>
  </button>
</div>

<!-- Account menu (avatar TS) — popover de conta substitui o atalho direto pro workspace -->`;
const ACCOUNT_MENU_MARKUP = `<div class="u-topbar-popover" id="topbarAccountMenu" hidden role="menu" aria-label="Conta">
  <div class="u-topbar-popover-account">
    <span class="u-topbar-popover-account-circle">${operatorInitials()}</span>
    <div class="u-topbar-popover-account-meta">
      <span class="u-topbar-popover-account-name">${TOPBAR_OPERATOR.name}</span>
      <span class="u-topbar-popover-account-mail">${TOPBAR_OPERATOR.role}</span>
    </div>
  </div>
  <div class="u-topbar-popover-sep" role="separator"></div>
  <button type="button" class="u-topbar-popover-item" role="menuitem" data-action="workspace">
    <i class="ti ti-briefcase" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Workspace pessoal</span>
    <kbd class="u-kbd">W</kbd>
  </button>
  <button type="button" class="u-topbar-popover-item" role="menuitem" data-action="settings">
    <i class="ti ti-settings" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Configurações</span>
  </button>
  <button type="button" class="u-topbar-popover-item" role="menuitem" data-action="signout">
    <i class="ti ti-logout" aria-hidden="true"></i>
    <span class="u-topbar-popover-item-label">Sair</span>
  </button>
</div>

<!-- Lightweight toast host para feedback das ações do overflow -->`;
const TOAST_HOST_MARKUP = `<div class="u-mini-toast-host" id="miniToastHost" aria-live="polite" aria-atomic="true"></div>`;
const SURFACE_DOCK_MARKUP = `<!-- Doca lateral unificada (estilo tab bar iOS / Liquid Glass) — agrupa
     os 3 launchers numa única cápsula de vidro flutuante. Estilo em
     assets/unified.css, seção "Surface dock". -->
<nav class="u-surface-dock" aria-label="Superfícies de inteligência">
<button type="button" id="crisisLauncher" class="crz-fab u-dock-item"
        aria-label="Gestão de crise indisponível" aria-haspopup="dialog" aria-expanded="false"
        disabled aria-disabled="true" data-tip="Gestão de Crise (indisponível)">
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3l7 2.5v5c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9v-5L12 3z" fill="currentColor" opacity="0.18"/>
    <path d="M12 3l7 2.5v5c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9v-5L12 3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
    <path d="M8.5 13.6a3.5 3.5 0 0 1 7 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <line x1="12" y1="13.6" x2="14.3" y2="10.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
  </svg>
</button>

<!-- ══════════════════════════════════════════════════════════════
     GESTÃO DE REPUTAÇÃO — botão redondo (launcher) no cluster esquerdo,
     logo abaixo do escudo da Crise. Ícone velocímetro (Reputation Index).
     ══════════════════════════════════════════════════════════════ -->
<button type="button" id="reputationLauncher" class="rep-fab u-dock-item"
        aria-label="Gestão de reputação indisponível" aria-haspopup="dialog" aria-expanded="false"
        disabled aria-disabled="true" data-tip="Gestão de Reputação (indisponível)">
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 16a8 8 0 0 1 16 0" fill="currentColor" opacity="0.16"/>
    <path d="M4 16a8 8 0 0 1 16 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <line x1="12" y1="16" x2="15.4" y2="11.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <circle cx="12" cy="16" r="1.5" fill="currentColor"/>
  </svg>
</button>

<!-- ══════════════════════════════════════════════════════════════
     COPILOTO IA — botão redondo (launcher) no cluster esquerdo, 3º slot.
     Carrega a marca ORBE (gradiente azul→índigo + glow), sinalizando "a IA".
     ══════════════════════════════════════════════════════════════ -->
<button type="button" id="copilotChatLauncher" class="cop-fab u-dock-item"
        aria-label="Copiloto IA indisponível" aria-haspopup="dialog" aria-expanded="false"
        disabled aria-disabled="true" data-tip="Copiloto IA (indisponível)">
  <i class="ti ti-sparkles" aria-hidden="true"></i>
</button>
</nav>`;
